import React from 'react';
import { Chip } from '@mui/material';
import { HiCircleStack, HiTrash } from 'react-icons/hi2';
import { FiBookmark } from 'react-icons/fi';
import './CreditPackageCard.css';

// Card component for displaying credit packages available for purchase
// Note: Displays hardcoded placeholder values - API data structure is ready for integration
const CreditPackageCard = ({ pkg, onRemove, onSave, quantity = 1, onQuantityChange, userType }) => {
    const totalPrice = pkg.price * quantity;

    // Calculate remaining time for credits
    const calculateCreditRemainingTime = (expiryType, expiryValue) => {
        const now = new Date();
        let endDate;

        if (expiryType === "date") {
            endDate = new Date(expiryValue);
            endDate.setHours(23, 59, 59, 999);
        } else if (expiryType === "days") {
            endDate = new Date(now);
            endDate.setDate(now.getDate() + Number(expiryValue));
        } else {
            return "Invalid expiry type";
        }

        if (endDate <= now) return "Expired";

        let years = endDate.getFullYear() - now.getFullYear();
        let months = endDate.getMonth() - now.getMonth();
        let days = endDate.getDate() - now.getDate();

        if (days < 0) {
            months--;
            const prevMonth = new Date(endDate.getFullYear(), endDate.getMonth(), 0);
            days += prevMonth.getDate();
        }

        if (months < 0) {
            years--;
            months += 12;
        }

        const parts = [];

        if (years > 0) parts.push(`${years} year${years > 1 ? "s" : ""}`);
        if (months > 0) parts.push(`${months} month${months > 1 ? "s" : ""}`);
        if (days > 0 || parts.length === 0)
            parts.push(`${days} day${days > 1 ? "s" : ""}`);

        return parts.length > 1
            ? parts.slice(0, -1).join(", ") + " and " + parts.at(-1)
            : parts[0];
    };

    return (
        <div className="credit-pkg-card">
            <div className="credit-pkg-content">
                <div className="credit-pkg-icon-wrapper">
                    <HiCircleStack className="credit-pkg-icon" />
                </div>

                {/* Title + sub-details stacked */}
                <div className="credit-pkg-details">
                    <h4 className="credit-pkg-title">{pkg.name}</h4>
                    <h4 className="credit-pkg-title">{pkg.credits} Credits</h4>
                    {userType === "parent" && pkg.user_code && (
                        <p className="credit-pkg-subtitle">For Student: {pkg.user_code}</p>
                    )}
                    <div className="credit-pkg-meta">
                        {pkg.credits_expiry_type && pkg.credits_expiry_duration && (
                            <span className="credit-pkg-meta-item">Credit active for {calculateCreditRemainingTime(pkg.credits_expiry_type, pkg.credits_expiry_duration)}</span>
                        )}
                        {pkg.price_before_discount && (
                            <span className="credit-pkg-meta-item">Price before discount: {pkg.price_before_discount.toFixed(2)} {pkg.currencySymbol}</span>
                        )}

                        {pkg.discount && (
                            <span className="credit-pkg-meta-item">Package Discount {pkg.discount}</span>
                        )}
                    </div>
                </div>

                {/* Quantity Stepper */}
                <div className="credit-pkg-qty">
                    <button
                        className="qty-btn"
                        onClick={() => onQuantityChange && onQuantityChange(Math.max(1, quantity - 1))}
                        aria-label="Decrease quantity"
                    >−</button>
                    <span className="qty-value">{quantity}</span>
                    <button
                        className="qty-btn"
                        onClick={() => onQuantityChange && onQuantityChange(quantity + 1)}
                        aria-label="Increase quantity"
                    >+</button>
                </div>

                {/* Total price chip */}
                <Chip
                    label={`${totalPrice.toFixed(2)} ${pkg.currencySymbol}`}
                    size="small"
                    className="credit-pkg-price-chip"
                />

                <div className="credit-pkg-actions">
                    <button
                        onClick={onSave}
                        className="credit-pkg-save-btn"
                        aria-label="Save package"
                    >
                        <FiBookmark />
                    </button>

                    <button
                        onClick={onRemove}
                        className="credit-pkg-remove-button"
                        aria-label="Remove package"
                    >
                        <HiTrash />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CreditPackageCard;
